import { formatInTimeZone, toZonedTime } from 'date-fns-tz';

/**
 * Returns 'd' in JST
 */
export default function formatDayOfMonth(utcTimestampSeconds: number): string {
  return formatInTimeZone(new Date(utcTimestampSeconds * 1000), 'Asia/Tokyo', 'd');
}
